// This class stores custom data about a particular series, such as visibility and color.
export class CustomSeriesData {
    public visible: boolean = true;
    public color: string|undefined;
}
  